import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useInternationalCallsUIContext } from "../InternationalCallsUIContext";
import {  useIntl} from "react-intl";
const prepareFilter = (queryParams, values) => {
  const { search } = values;
  const newQueryParams = { ...queryParams };
  const filterBy = [];
 
  // Filter by status
  // filter.status = status !== "" ? +status : undefined;
  // Filter by type
  // filter.type = type !== "" ? +type : undefined;
  // Filter by all fields
  // filter.lastName = searchText;
 // if (search) {
  newQueryParams.search = search;
    //filter.search= search;
  //}
  newQueryParams.filterBy = filterBy;
  return newQueryParams;
};

export function InternationalCallsFilter({ listLoading }) {
   const intl = useIntl();
  // InternationalCalls UI Context
  const internationalCallsUIContext = useInternationalCallsUIContext();
  const internationalCallsUIProps = useMemo(() => {
    return {
      queryParams: internationalCallsUIContext.queryParams,
      setQueryParams: internationalCallsUIContext.setQueryParams,
    };
  }, [internationalCallsUIContext]);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(internationalCallsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, internationalCallsUIProps.queryParams)) {
      newQueryParams.page = 0;
      // update list by queryParams
      internationalCallsUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          // status: "", // values => All=""/Susspended=0/Active=1/Pending=2
          // type: "", // values => All=""/Business=0/Individual=1
          search: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-12">
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  placeholder={intl.formatMessage({ id: "ECOMMERCE.COMMON.SEARCH" })}
                  onBlur={handleBlur}
                  value={values.search}
                  onChange={(e) => {
                    setFieldValue("search", e.target.value);
                    handleSubmit();
                  }}
                />
                {/* <small className="form-text text-muted">
                  <b>Search</b> in all fields
                </small> */}
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
